import saveAs from 'file-saver';
import lodash from 'lodash';
import { EnumAPI } from '../../apis';
import { AjaxBasics, BaseModel } from './../../libraries';
import { createUserModel } from './userInfo';
export class PPTController {
    constructor() {
        this.Model = new BaseModel({ type: 'object' });
        //用户数据
        this.UserInfo = createUserModel();
    }
    get liveId() {
        return lodash.get(this.UserInfo.value, 'liveId');
    }
    get livePPTdownList() {
        return lodash.get(this.Model.value, 'livePPTdownList', []);
    }
    get currentImageUrl() {
        return lodash.get(this.Model.value, 'url');
    }
    get pptName() {
        return lodash.get(this.Model.value, 'name');
    }
    get currentPage() {
        return lodash.get(this.Model.value, 'currentPage');
    }
    get totalPage() {
        return lodash.get(this.Model.value, 'totalPage');
    }
    get isOpen() {
        return lodash.get(this.Model.value, 'isOpen');
    }
    get isDownload() {
        return lodash.size(this.livePPTdownList);
    }
    get allowTurnPage() {
        return lodash.get(this.Model.value, 'allowTurnPage');
    }
    onInit() {
        const url = Mudu.Room.PPT.GetUrl();
        //获取ppt名称
        const name = Mudu.Room.PPT.GetName();
        //获取当前控制台ppt所在页数
        const currentPage = Mudu.Room.PPT.GetCurrentPage();
        //获取当前ppt总页数
        const totalPage = Mudu.Room.PPT.GetTotalPage();
        //获取控制台是否开启显示PPT
        const isOpen = Mudu.Room.PPT.IsOpen();
        //获取控制台是否允许用户翻页
        const allowTurnPage = Mudu.Room.PPT.GetAllowTurnPage();
        this.getPPTdownList();
        this.Model.merge({
            url,
            name,
            currentPage,
            totalPage,
            isOpen,
            allowTurnPage,
        });
    }
    async getPPTdownList() {
        try {
            const response = await AjaxBasics.request(lodash.assign(EnumAPI.live_download_list, {
                body: {
                    liveId: this.liveId,
                },
            }));
            this.Model.merge({
                livePPTdownList: response,
            });
        }
        catch (error) { }
    }
    //根据页码获取相应的ppt图片地址
    onGetPageImgUrl(pageNum) {
        Mudu.Room.PPT.GetPageImgUrl(pageNum, (url) => {
            this.Model.merge({
                url,
                currentPage: pageNum,
            });
        });
    }
    onPPTListener() {
        Mudu.MsgBus.On('PPT.Changed', (response) => {
            response = JSON.parse(response);
            const { page, total_page, url } = response;
            this.Model.merge({
                url,
                currentPage: page,
                totalPage: total_page,
            });
        });
        Mudu.MsgBus.On('PPT.IsOpen', (response) => {
            response = JSON.parse(response);
            const { open, page, total_page, url } = response;
            this.Model.merge({
                url,
                currentPage: page,
                totalPage: total_page,
                isOpen: lodash.eq(open, 1),
            });
        });
        Mudu.MsgBus.On('PPT.AllowTurnPage', (response) => {
            response = JSON.parse(response);
            //切换后是否允许用户翻页, 1为允许, 0为禁止
            const { is_turn_page } = response;
            this.Model.merge({
                allowTurnPage: lodash.eq(is_turn_page, 1),
            });
        });
        Mudu.MsgBus.On('PPT.Doc.delete', () => {
            // 无参数
        });
    }
    /**
     *  ppt下载
     */
    async onPPTDown(id) {
        try {
            const res = await AjaxBasics.request(lodash.assign({}, EnumAPI.live_ppt_down, {
                body: { id },
                responseType: 'blob',
            }));
            const disposition = res.xhr.getResponseHeader('content-disposition');
            const match = disposition.match(/filename\s*=\s*"([^"]*)"/i);
            let dispositionFilename = '';
            if (match) {
                dispositionFilename = decodeURI(match[1]);
            }
            else {
                /^attachment;\s{0,}filename=(.*)/i.test(disposition);
                dispositionFilename = decodeURI(RegExp.$1);
            }
            if (dispositionFilename) {
                saveAs(res.response, dispositionFilename);
            }
            else {
                console.log('下载异常~');
            }
        }
        catch (error) {
            console.log('下载异常');
        }
    }
}
